import DefaultLogo from 'assets/brand/superorder-big.svg?react';
import styled from 'styled-components';
import DefaultSpinner from 'components/Spinner';

export const Logo = styled(DefaultLogo)``;

export const Spinner = styled(DefaultSpinner)`
  margin-top: 2rem;
`;

// TODO: TFR-44 move to container group or do not export
const Container = styled.div`
  background: ${({ theme }) => theme.colors.greenDark};
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export default Container;
